import { render } from "./MedicalInfo.vue?vue&type=template&id=6c8fe3d8&scoped=true"
import script from "./MedicalInfo.vue?vue&type=script&lang=js"
export * from "./MedicalInfo.vue?vue&type=script&lang=js"

import "./MedicalInfo.vue?vue&type=style&index=0&id=6c8fe3d8&scoped=true&lang=css"

import exportComponent from "/Volumes/Transcend INNCOM/INNCOM Project/2103.musoon.mobile.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8fe3d8"]])

export default __exports__